import React from "react";
import ProjectsPanel from "src/pages/Projects/Panel";

import RoutePrivate from "./private";

export default [
	<RoutePrivate path="/projects/panel" key="projectspanel" exact component={ProjectsPanel} isPrivate/>,
	<RoutePrivate path="/projects/panel/:projectId" permissionPath="/projects/panel" key="projectspanelprojectId" exact component={ProjectsPanel} isPrivate/>
];
